/* (c) Copyright 2020 Pivotal Software, Inc. All Rights Reserved. */
"use strict";

exports.__esModule = true;
exports.TrWithDrawer = exports.TrWithoutDrawer = exports.TrHeaderForDrawers = exports.Th = exports.Td = exports.Tr = exports.Tfoot = exports.Tbody = exports.Thead = exports.Caption = exports.Table = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _classnames = _interopRequireDefault(require("classnames"));

require("../../css/tables/index.js");

var _collapsible = require("../collapsible");

var _iconography = require("../iconography");

var _buttons = require("../buttons");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; if (obj != null) { var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; subClass.__proto__ = superClass; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var Table = function Table(_ref) {
  var className = _ref.className,
      props = _objectWithoutPropertiesLoose(_ref, ["className"]);

  return _react["default"].createElement("table", _extends({}, props, {
    className: (0, _classnames["default"])('pui-table', className)
  }));
};

exports.Table = Table;

var Caption = function Caption(_ref2) {
  var className = _ref2.className,
      children = _ref2.children,
      props = _objectWithoutPropertiesLoose(_ref2, ["className", "children"]);

  return _react["default"].createElement("caption", _extends({}, props, {
    className: (0, _classnames["default"])(className, 'em-high h5 txt-l')
  }), children);
};

exports.Caption = Caption;

var Thead = function Thead(props) {
  return _react["default"].createElement("thead", props);
};

exports.Thead = Thead;

var Tbody = function Tbody(props) {
  return _react["default"].createElement("tbody", props);
};

exports.Tbody = Tbody;

var Tfoot = function Tfoot(props) {
  return _react["default"].createElement("tfoot", props);
};

exports.Tfoot = Tfoot;

var Tr = function Tr(props) {
  return _react["default"].createElement("tr", props);
};

exports.Tr = Tr;

var Td = function Td(props) {
  return _react["default"].createElement("td", props);
};

exports.Td = Td;

var Th = function Th(_ref3) {
  var _ref3$scope = _ref3.scope,
      scope = _ref3$scope === void 0 ? 'col' : _ref3$scope,
      props = _objectWithoutPropertiesLoose(_ref3, ["scope"]);

  return _react["default"].createElement("th", _extends({}, props, {
    scope: scope
  }));
};

exports.Th = Th;

var TrHeaderForDrawers = function TrHeaderForDrawers(_ref4) {
  var children = _ref4.children;
  return _react["default"].createElement(Tr, null, _react["default"].createElement(Th, {
    className: "pui-table--collapsible-toggle border-right-0"
  }), children);
};

exports.TrHeaderForDrawers = TrHeaderForDrawers;

var TrWithoutDrawer = function TrWithoutDrawer(_ref5) {
  var children = _ref5.children;
  return _react["default"].createElement(Tr, null, _react["default"].createElement(Td, {
    className: "pui-table--collapsible-toggle border-right-0"
  }), children);
};

exports.TrWithoutDrawer = TrWithoutDrawer;

var TrWithDrawer = /*#__PURE__*/function (_React$PureComponent) {
  _inheritsLoose(TrWithDrawer, _React$PureComponent);

  function TrWithDrawer() {
    var _this;

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _React$PureComponent.call.apply(_React$PureComponent, [this].concat(args)) || this;

    _defineProperty(_assertThisInitialized(_this), "state", {
      expanded: false
    });

    return _this;
  }

  var _proto = TrWithDrawer.prototype;

  _proto.render = function render() {
    var _this2 = this;

    var _this$props = this.props,
        ariaLabelCollapsed = _this$props.ariaLabelCollapsed,
        ariaLabelExpanded = _this$props.ariaLabelExpanded,
        children = _this$props.children,
        className = _this$props.className,
        drawerContent = _this$props.drawerContent,
        onExpand = _this$props.onExpand;
    var expanded = this.state.expanded;
    return _react["default"].createElement(_react.Fragment, null, _react["default"].createElement(Tr, {
      className: (0, _classnames["default"])({
        'border-bottom': !expanded
      })
    }, _react["default"].createElement(Td, {
      className: (0, _classnames["default"])('border-right-0', {
        'active-indicator': expanded
      })
    }, _react["default"].createElement(_buttons.DefaultButton, {
      className: "pui-table--collapsible-btn",
      icon: _react["default"].createElement(_iconography.Icon, {
        src: "chevron_right",
        className: (0, _classnames["default"])('transition-transform', {
          'rotate-qtr-turn': expanded
        })
      }),
      onClick: function onClick() {
        if (!expanded && onExpand) onExpand();

        _this2.setState(function (_ref6) {
          var expanded = _ref6.expanded;
          return {
            expanded: !expanded
          };
        });
      },
      iconOnly: true,
      flat: true,
      "aria-label": expanded ? ariaLabelExpanded : ariaLabelCollapsed
    })), children), _react["default"].createElement(Tr, {
      className: (0, _classnames["default"])(className, {
        'border-top-0 display-none': !expanded
      })
    }, _react["default"].createElement(Td, {
      colSpan: 1 + children.length,
      className: "pan"
    }, _react["default"].createElement(_collapsible.Collapsible, {
      expanded: expanded
    }, drawerContent))));
  };

  return TrWithDrawer;
}(_react["default"].PureComponent);

exports.TrWithDrawer = TrWithDrawer;

_defineProperty(TrWithDrawer, "propTypes", {
  ariaLabelCollapsed: _propTypes["default"].string.isRequired,
  ariaLabelExpanded: _propTypes["default"].string.isRequired,
  drawerContent: _propTypes["default"].node,
  onExpand: _propTypes["default"].func,
  children: _propTypes["default"].node
});